import { Injectable } from '@angular/core';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { GridRow } from '@app/core/components/grid/grid.types';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { CustomerAccountInfo } from '@app/services/typeahead.service';

@Injectable({
    providedIn: 'root',
})
export class AcCustTransService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 2794
     * @datataskName sp_ws_p2_w_accusttranses_get
     * @returns promise containing page get for ac-cust-transes.
     */
    public async getAcCustTranses(params: GetAcCustTransesParams): Promise<AcCustTransesGet> {
        const page = (await this.datatask.Post(2794, params))[0] as AcCustTransesResponse;

        return { ...page, customers: JSON.parse(page.customers || '[]') as CustomerAccountInfo[] };
    }

    /**
     * @datatask 2821
     * @datataskName sp_ws_p2_accusttranses_remove_matching
     * @returns promise containing validation for the removing of matching.
     */
    public async removeAcCustTransesMatching(params: AcCustTransesGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2821, params))[0];
    }

    /**
     * @datatask 2822
     * @datataskName sp_ws_p2_accusttranses_match_selected
     * @returns promise containing validation for the matching.
     */
    public async matchSelectedAcCustTranses(params: MatchSelectedAcCustTransesParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2822, params))[0];
    }

    /**
     * @datatask 2823
     * @datataskName sp_ws_p2_accusttranses_automatch
     * @returns promise containing validation fo the auto mathc.
     */
    public async autoMatchAcCustTranses(params: AcCustTransesGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2823, params))[0];
    }

    /**
     * @datatask 2831
     * @datataskName sp_ws_p2_w_accusttrans_get
     * @param params the keyno of the accusttrans to get.
     * @returns promise containing the accusttrans.
     */
    public async getAcCustTrans(params: GetAcCustTransParams): Promise<AcCustTransGet> {
        return (await this.datatask.Post(2831, params))[0];
    }

    /**
     * @datatask 2833
     * @datataskName sp_ws_p2_w_accusttrans_remove_matching_selected
     * @param params the accusttrans and the records to remove match on.
     * @returns promise containing validation.
     */
    public async removeAcCustTransMatching(params: RemoveAcCustTransMatchingParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2833, params))[0];
    }
}

export interface GetAcCustTransParams {
    accusttrans_keyno: string;
}

export interface GetAcCustTransesParams {
    argtype: string;
    argvalue: string;
}

export interface AcCustTransGet {
    accusttrans_keyno: string;
    heading_matching: string;
}

export interface AcCustTransesGet {
    page_heading: string;
    businessco_no: string;
    openpost: '0' | '1';
    show_account_saldo: '0' | '1';
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    date_fomtom: string;
    date_tom_open_post: string;
    date_today: string;
    date_not_today_warning: string;
    acc_cust_no: string;
    customers: CustomerAccountInfo[];
}

export interface AcCustTransesGridRow extends GridRow {
    orderby: number;
    accusttrans_keyno: number;
    acvoucher_keyno: number;
    accusttranstype: string;
    acc_cust_no: number;
    cust_name: string;
    voucherdate: string;
    transdate: string;
    duedate: string;
    expected_paydate: string;
    amount_locval: number;
    amount_invval: number;
    valuta_id: string;
    exchange_rate: number;
    account_no: number;
    voucher_no: number;
    interest_from_date: string;
    interest_to_date: string;
    interest_rate: number;
    payed_date: string;
    payment_id: string;
    invoice_no: number;
    order_order_no: number;
    note: string;
    note2: string;
    custact_no: number;
    acvouchertype_id: string;
    kid: string;
    accusttrans_keyno_relatedto: number;
    acvoucher_keyno_relatedto: number;
    businessco_no: number;
    acvatcode: number;
    invoiceline_keyno: number;
    interest_amount_locval_base: number;
    interes_amount_innval_base: number;
    interest_status: string;
    matchdate: string;
    acremltr_no_last: number;
    acremltr_date_last: string;
    acremltr_stop: string;
    amount_locval_balance: number;
    voucher_no_match: string;
    rem_invoice_no: string;
    case_number: string;
    reminder_status: string;
    invoice_paid_to: string;
    acremltr_gen: string;
    debit_account_no: string;
    factoring_no: number;
    recordtype: string;
    is_selected: boolean;
    is_selected_amount_locval_balance: number;
    project: string;
    dispute: boolean;
    amount_locval_abs: number;
    total_amount_text: string;
}

export interface RemoveAcCustTransMatchingParams extends AcCustTransGet {
    records: { accusttransmatch_keyno: string | number }[];
}

export interface MatchSelectedAcCustTransesParams extends AcCustTransesGet {
    records: { accusttrans_keyno: number }[];
}

interface AcCustTransesResponse extends Omit<AcCustTransesGet, 'customers'> {
    customers: string;
}
